export const scrollbarStyles = {
  none: {
    // Hide scrollbar on Chrome, Safari, Edge
    "&::-webkit-scrollbar": {
      display: "none",
    },

    // Hide scrollbar on Firefox
    scrollbarWidth: "none" as const,
    // For older Firefox versions
    "&": {
      scrollbarWidth: "none" as const,
      "-ms-overflow-style": "none", // IE and Edge
    },
  },
};
